
export const PROCESSING_STATUSES: ProcessingStatus[] = ['For Revision', 'For Approval'];
export const PROCESSED_STATUSES = ['Processed', 'Completed'] as const
export const ALL_STATUSES = [...PROCESSING_STATUSES, ...PROCESSED_STATUSES] as const

export type ProcessingStatus = 'For Revision' | 'For Approval';
export type ProcessedStatus = typeof PROCESSED_STATUSES[number]
export type TicketStatus = typeof ALL_STATUSES[number]

export const isProcessingStatus = (status: string): status is ProcessingStatus => 
  PROCESSING_STATUSES.includes(status as ProcessingStatus)

export const isProcessedStatus = (status: string): status is ProcessedStatus => 
  PROCESSED_STATUSES.includes(status as ProcessedStatus)
